(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Address", [], factory);
	else if(typeof exports === 'object')
		exports["Address"] = factory();
	else
		root["Address"] = factory();
})(this, function() {
return 